// services/userService.js

/**
 * Service for handling user profile management API calls
 */
const userService = (apiClient) => ({
  /**
   * Get current user profile
   * @returns {Promise<Object>} - User profile data
   */
  getCurrentUser: async () => {
    try {
      const response = await apiClient.get('/auth/me');
      return response.data;
    } catch (error) {
      console.error('Get current user error:', error);
      throw error;
    }
  },

  /**
   * Update user profile
   * @param {Object} profileData - User profile data to update
   * @returns {Promise<Object>} - Updated user profile data
   */
  updateProfile: async (profileData) => {
    try {
      const response = await apiClient.put('/auth/me', profileData);
      return response.data;
    } catch (error) {
      console.error('Update profile error:', error);
      throw error;
    }
  },

  /**
   * Check if user has completed profile setup
   * @param {Object} user - User object
   * @returns {boolean} - True if profile is complete
   */
  isProfileComplete: (user) => {
    if (!user) return false;

    // Required fields for profile completion
    const requiredFields = ['city', 'address', 'country', 'contactDetailsValue'];

    return requiredFields.every(field =>
      user[field] && user[field].toString().trim() !== ''
    );
  }
});

export default userService;